import { useEffect, useState } from 'react'
import prefersReducedMotion from '@/shared/tools/prefersReducedMotion'

const TYPE_MS = 35
const ROTATE_MS = 5000

const useTypedExample = (examples: string[]) => {
  const [index, setIndex] = useState(0)
  const [typed, setTyped] = useState(0)
  const example = examples.length ? examples[index % examples.length] : ''

  useEffect(() => {
    if (examples.length < 2) return undefined
    const rotation = window.setInterval(() => {
      if (!document.hidden) setIndex(current => current + 1)
    }, ROTATE_MS)
    return () => window.clearInterval(rotation)
  }, [examples.length])

  useEffect(() => {
    if (prefersReducedMotion()) {
      setTyped(example.length)
      return undefined
    }
    setTyped(0)
    const typer = window.setInterval(() => {
      setTyped(current => Math.min(current + 1, example.length))
    }, TYPE_MS)
    const stop = window.setTimeout(() => window.clearInterval(typer), TYPE_MS * (example.length + 1))
    return () => {
      window.clearInterval(typer)
      window.clearTimeout(stop)
    }
  }, [example])

  return example.slice(0, typed)
}

export default useTypedExample
